/* still.hobbies — calm scroll animations
 *
 * Anything marked `data-still-fade` in the DOM gets a gentle fade-and-rise
 * as it scrolls into view. Runs once per element. Honors
 * `prefers-reduced-motion` by showing the element instantly.
 *
 * Intentionally plain JS, no dependencies, no build step.
 */
(function () {
  'use strict';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markVisible(el) {
    el.classList.add('still-fade--in');
  }

  function init() {
    var targets = document.querySelectorAll('[data-still-fade]');
    if (!targets.length) return;

    // Apply the "before" state up-front so we don't get a flash of the
    // final position during initial render.
    Array.prototype.forEach.call(targets, function (el) {
      if (reduceMotion) {
        markVisible(el);
      } else {
        el.classList.add('still-fade');
      }
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(targets, markVisible);
      return;
    }

    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          markVisible(entry.target);
          obs.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -8% 0px',
    });

    Array.prototype.forEach.call(targets, function (el) { obs.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
